/**
 * CancelTagIcon Component
 *
 * Small (14×14) outlined circle with × inside. Used as an error marker in
 * compact inline contexts like the BulkPublishBar failure toast.
 * Based on Figma design: 1px stroke, 5px inner × centred in a 14px circle.
 *
 * For the larger 24×24 row-cell variant, see `CancelledIcon`.
 */

export function CancelTagIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="currentColor" />
      <path d="M4.5 4.5L9.5 9.5" stroke="currentColor" />
      <path d="M9.5 4.5L4.5 9.5" stroke="currentColor" />
    </svg>
  );
}
